import { render, staticRenderFns } from "./captain.vue?vue&type=template&id=1cfd090c&"
import script from "./captain.vue?vue&type=script&lang=js&"
export * from "./captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports